// Dedicated Apollo client for manually-added prior studies (GET_PRIOR_STUDY).
//
// WHY a separate client/cache: manual priors are fetched in `useManualPriorStudies`
// with `cache-first`. If those writes land in the MAIN normalized cache, every
// prior-add broadcasts to the main GET_BASE_VIEWER_DATA (GBVD) watch, forcing
// Apollo to re-diff/`makeCacheKey` the huge main-case result synchronously on the
// main thread (the multi-second prior-add freeze). Isolating prior writes into
// their own InMemoryCache means adding a prior no longer touches the GBVD watch,
// while we keep fetches deduped/cached via `cache-first`.
//
import { ApolloClient, InMemoryCache } from '@apollo/client';
import { APP_VERSION } from 'config/constants';
import { dataIdFromObject, typePolicies } from './cacheConfig';
import { link } from './links';

export const priorClient = new ApolloClient({
  link,
  cache: new InMemoryCache({ typePolicies, dataIdFromObject }),
  clientAwareness: {
    name: 'prior-studies',
    version: APP_VERSION,
  },
});
